// 用户信息

import RequestUtils from "@/request/index";

const url = `/mobile/emp`;

class EmpService {
    /** 修改用户信息 */
    update(data,attachmentIds) {
        return RequestUtils.post({
            url: `${url}/update`,
            data,
            params: {attachmentIds}
        });
    }

    /** 修改密码 */
    updatePwd(data) {
        return RequestUtils.post({
            url: `${url}/updatePwd`,
            data,
            params: {}
        });
    }

    /** 获取当前用户信息 */
    get() {
        return RequestUtils.get({
            url: `${url}/get`,
        });
    }
}

export default new EmpService();
